import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import QuestionBankManager from '../features/questionBank/QuestionBankManager';
import TestManager from '../features/tests/TestManager';
import LessonTestManager from '../features/lessonTests/LessonTestManager';
import '../styles/AdminDashboard.css';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('questions');
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <div className="admin-dashboard">
      <header className="dashboard-header">
        <h1>Test Administration</h1>
        <div className="header-actions">
          <span className="user-email">{currentUser?.email}</span>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </header>

      <nav className="dashboard-nav">
        <button
          className={`nav-tab ${activeTab === 'questions' ? 'active' : ''}`}
          onClick={() => setActiveTab('questions')}
        >
          📝 Question Bank
        </button>
        <button
          className={`nav-tab ${activeTab === 'tests' ? 'active' : ''}`}
          onClick={() => setActiveTab('tests')}
        >
          📋 Tests
        </button>
        <button
          className={`nav-tab ${activeTab === 'lessonTests' ? 'active' : ''}`}
          onClick={() => setActiveTab('lessonTests')}
        >
          🎯 Lesson Tests
        </button>
      </nav>

      <main className="dashboard-content">
        {activeTab === 'questions' && <QuestionBankManager />}
        {activeTab === 'tests' && <TestManager />}
        {activeTab === 'lessonTests' && <LessonTestManager />}
      </main>
    </div>
  );
};

export default AdminDashboard;